export default "__VITE_ASSET__d1b374a5__"